import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Country } from '@shared/models/country';

export const countryAdapter: EntityAdapter<Country> = createEntityAdapter<Country>({
  selectId: (country) => country.englishName,
});
